import { serializerCtx } from '@milkdown/kit/core'
import { Plugin, PluginKey } from '@milkdown/kit/prose/state'
import { $prose } from '@milkdown/kit/utils'

const charLimitKey = new PluginKey('rich-text-editor-char-limit')

export const NoLineBreakPlugin = $prose(() => {
    return new Plugin({
        props: {
            handleKeyDown: (_, event) => {
                if (event.key !== 'Enter') {
                    return false
                }

                event.preventDefault()
                return true
            },
            handlePaste: (view, event, slice) => {
                const plainText = event.clipboardData?.getData('text/plain') ?? ''
                const fallbackText = slice.content.textBetween(0, slice.content.size, '\n', ' ')
                const inputText = plainText || fallbackText

                if (!inputText || !/[\r\n]/.test(inputText)) {
                    return false
                }

                event.preventDefault()

                const sanitizedText = inputText.replace(/[\r\n]+/g, ' ')
                const { from, to } = view.state.selection
                view.dispatch(view.state.tr.insertText(sanitizedText, from, to))

                return true
            },
        },
    })
})

export const CharacterLimitPlugin = (maxLength: number) =>
    $prose((ctx) => {
        return new Plugin({
            key: charLimitKey,
            filterTransaction: (transaction, state) => {
                if (!transaction.docChanged || !maxLength) {
                    return true
                }

                const serializer = ctx.get(serializerCtx)
                const oldSize = serializer(state.doc).length
                const newSize = serializer(transaction.doc).length

                // Markdown lengths are not document positions: a placeholder is a single atomic node.
                // Keep existing oversized content editable without trimming it automatically.
                return newSize <= maxLength || (oldSize > maxLength && newSize <= oldSize)
            },
        })
    })
